export default {
  transferPortalUpdate: "Transfer Portal Update"
};
